import React from "react";
import { useHistory } from "react-router";
import { getNumberWithUnit } from "../SharedFunction";
import { useState } from "react";
import { Avatar, Col, Drawer, Row } from "antd";
import { Spinner } from "@public/ui-toolkit";
import { createChatRoom } from "../../../hedgefund-portal/src/containers/Profile/actions";
import { useDispatch } from "react-redux";

const RoomType = [
  {
    id: 0,
    name: "Private"
  },
  {
    id: 1,
    name: "Group"
  }
]
const SearchAllocatorsCard = ({
  allocator,
  img,
  logo,
  isFooterShow = false,
  getAllocatorUsers,
  allocatorUsers = [],
  followFundHandler
}) => {
  const [chatLoading, setChatLoading] = useState(false);
  const [follow, setFollow] = useState(allocator?.follow);
  const [userDrawer, setUserDrawer] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const items = [
    {
      id: "0",
      fullName: allocator?.name,
      profileUrl: allocator?.logo,
      title: "Allocator Chat"
    },
    ...allocatorUsers
  ];
  const onChatClickHandler = (key) => {
    const body = {
      tenantId: allocator?.id,
      type: key === "0" ? RoomType[1].id : RoomType[0].id,
      ...(key !== "0" && { userId: key }),
    };
    joinChatRoom(body);
  }
  const clickZoomMeetingHandler = () => {
    history.push(`/allocator?allocatorId=${allocator?.id}`);
  };
  const joinChatRoom = (body) => {
    dispatch(
      createChatRoom(body, (roomId) => {
        history.push(`/chat?identifier=${roomId}&type=1`);
      }))
  }
  return (
    <div className="hf-card h-100">
      <div
        className="hf-card-banner"
      >
        <img src={logo} onClick={() => history.push(`/allocator?allocatorId=${allocator?.id}`)} className="banner-img" alt="..." />
        {/* <img  onClick={() => history.push(`/allocator?allocatorId=${allocator?.id}`)} className="user-Fund-Card" src={logo} alt="Profile Image" /> */}
      </div>
      <div className="hf-card-body p-3" style={{ textAlign: "center" }}>
        <ul className="extra-info mt-2">
          <li className="mb-2">

            <span className="text-dark" onClick={() => history.push(`/allocator?allocatorId=${allocator?.id}`)} style={{ fontSize: "22px", fontWeight: "600" }}>
              {allocator?.name}
            </span>
          </li>
          <li className="mb-3">
            <i className="fa fa-map-marker mr-1"></i>
            <span className="text-blue">
              {allocator?.address
                ? allocator?.address
                : "N/A"}
            </span>
          </li>
          <li className="mb-3">
            <span class="badge badge-info p-2 mr-1">AUM: {allocator?.aum
              ? getNumberWithUnit(allocator?.aum)
              : "N/A"} </span>
            <span class="badge badge-secondary p-2 ">Investor Type: {allocator?.investorType ? allocator?.investorType?.name : 'Not Available'} </span>
          </li>
        </ul>
      </div>
      {isFooterShow && (
        <div className="hf-card-footer">
          <div className="row" style={{ height: '50px' }}>
            <div className="col-lg-4 p-0">
              <button
                className="border-0 bg-transparent p-0 btn-fund-card"
                onClick={() => {
                  followFundHandler(allocator?.id, !allocator?.follow);
                  setFollow(!allocator?.follow)
                }}
              >
                <i className={`fa ${!follow ? "fa-plus-square" : "fa-check"} mr-1`}></i>
                {follow ? "Followed" : "Follow"}
              </button>

            </div>
            <div className="col-lg-4 p-0">
              <button
                className="border-0 bg-transparent p-0 btn-fund-card"
                onClick={clickZoomMeetingHandler}

              >
                <i className="fa fa-phone mr-1" ></i>
                Schedule Meeting
              </button>
            </div>
            <div className="col-lg-4 p-0">
              <button
                className="border-0 bg-transparent p-0 btn-fund-card"
                onClick={() => {
                  getAllocatorUsers(allocator?.id);
                  setUserDrawer(true);
                }}
              >
                <i className="fa fa-comments mr-1"></i>
                Chat
              </button>
            </div>
          </div>
          <Drawer title="Allocator Users" open={userDrawer} onClose={() => setUserDrawer(false)}  >
            <Row className="mt-3" style={{ backgroundColor: "rgb(245 245 245)", padding: "10px" }}>
              {items?.length > 0 ? (
                items?.map((item) => {
                  return (
                    <Col span={24}>
                      <Row onClick={() => onChatClickHandler(item?.id)}>
                        <Col span={7}>
                          <Avatar src={item?.profileUrl} style={{ height: "70px", width: '70px' }} size={"large"} />
                        </Col>
                        <Col span={17}>
                          <Row>
                            <Col span={24} style={{ color: "#3ac1b5" }}>
                              {item?.fullName}
                            </Col>
                            <Col span={24}> {item?.title ? item?.title : "N/A"} </Col>
                          </Row>
                        </Col>
                      </Row>
                      <hr style={{ fontSize: "5px", marginLeft: "15px", marginRight: "15px" }} />
                    </Col>
                  )
                })
              ) : (
                <Spinner />
              )
              }
            </Row>
          </Drawer>
        </div>
      )}
    </div>
  );
};

export default SearchAllocatorsCard;
